import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useEnv } from '@zenbusiness/application-commons-env';

export const useDashboardPath = (suffix = '') => {
  const { businessEntityUuid } = useBusinessEntity();

  const { PARENT_SEGMENT = '/dashboard' } = useEnv();

  return `${PARENT_SEGMENT}/${businessEntityUuid}${suffix}`;
};
